export var loadingSpinnerActions = {
    SHOW_SPINNER_MODAL: 'SHOW_SPINNER_MODAL',
    HIDE_SPINNER_MODAL: 'HIDE_SPINNER_MODAL',
};



//////////////////
// WEBPACK FOOTER
// ./src/actions/loadingSpinnerActions.ts
// module id = 11
// module chunks = 0